import type { ComponentProps, Ref } from 'react';
import { cn } from '@/lib/utils';

type InputProperties = ComponentProps<'input'> & {
  ref?: Ref<HTMLInputElement> | null;
};

const Input = ({ className, type, ref, ...properties }: InputProperties) => (
  <input
    ref={ref}
    type={type}
    data-slot="input"
    className={cn(
      'flex h-9 w-full min-w-0 rounded-md border border-border/60 bg-card/80 px-3 py-1 text-base text-foreground shadow-[0001px_rgba(255,255,255,0.02)] transition-colors outline-none placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:px-2 file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
      'focus-visible:border-ring/60 focus-visible:ring-2 focus-visible:ring-ring/20',
      'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
      className
    )}
    {...properties}
  />
);

export { Input };
